import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sourceMarqueursIntoLegend'
})
export class SourceMarqueursIntoLegendPipe implements PipeTransform {
  transform(sourceMarqueurs: any, fixedLegend: { label: string, description: string | undefined | null }[]): { label: string, description: string, index: number }[] {
    if (Array.isArray(sourceMarqueurs)) {
      const toDisplay = [...fixedLegend, ...sourceMarqueurs.slice(fixedLegend.length)].map((marqueur, index) => ({
        label: typeof marqueur.label === 'string' ? marqueur.label : '',
        description: typeof marqueur.description === 'string' ? marqueur.description : '',
        index
      }));
      return toDisplay;
    } else {
      const toDisplay = fixedLegend.map((marqueur, index) => ({
        label: typeof marqueur.label === 'string' ? marqueur.label : '',
        description: typeof marqueur.description === 'string' ? marqueur.description : '',
        index
      }));
      return toDisplay;
    }
  }
}